export const PLAYER_INFORMATION_URL = (playerId, tenantCode, queryParameters) =>`${tenantCode}/cms/players/${playerId}?${queryParameters}`;
export const VALIDATE_PLAYER_PIN_URL = (playerId, tenantCode) =>`${tenantCode}/cms/players/${playerId}/pin/validate`;
export const UPDATE_PLAYER_INFORMATIN_URL = (playerId, tenantCode) => `${tenantCode}/cms/players/${playerId}`;
